/**
 * Wraps a value in a GraphQL filter case, e.g. `{equals: value}` / `{in: value}`.
 *
 * Pure wrapper — no type casting. Values coming from TDA-driven filters must be cast
 * beforehand with `coerceTdaValue` from @dreebit-registry/vsm-microservice-components,
 * which uses the attribute's `type` instead of guessing from the value (a text
 * attribute whose value happens to be "true" must stay a string).
 */
const getFilter = (value: any | undefined, comparator: any) => {
    if (value === undefined || value === null) {
        return null;
    }

    return {[comparator]: value};
}

export default getFilter;
